var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrintFileTemplateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2526 2.5H3.7526C2.83594 2.5 2.08594 3.25 2.08594 4.16667V15.8333C2.08594 16.75 2.83594 17.5 3.7526 17.5H16.2526C17.1693 17.5 17.9193 16.75 17.9193 15.8333V4.16667C17.9193 3.25 17.1693 2.5 16.2526 2.5ZM16.2526 4.16667V6.66667H3.7526V4.16667H16.2526ZM12.0859 15.8333H7.91927V8.33333H12.0859V15.8333ZM3.7526 8.33333H6.2526V15.8333H3.7526V8.33333ZM13.7526 15.8333V8.33333H16.2526V15.8333H13.7526Z",
    fill: "#1D1B20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintFileTemplateIcon);
export default __webpack_public_path__ + "static/media/print_file_template_icon.60715a85868c28fa617ac2962c75b5f9.svg";
export { ForwardRef as ReactComponent };